import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaMedal} from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import HyvidRewards from "./index";
import { MODULE_REWARDS } from "variables/constants";

const hyvidRewardRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Hyvid Rewards",
		basePath: "hyvid-rewards",
		mainComponent: <HyvidRewards />,
	    layout: "/console",	   
	    icon: <FaMedal className="icon-item" />,
	    subTitle:"Hyvid Rewards",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_REWARDS,
	})
]

export default hyvidRewardRoutes;